/**
 * Rainbow stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const rainbowStickersPack: ToilePack = {
    slug: 'rainbow-stickers',
    category: 'sticker',
    name: 'Rainbow stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'arc', label: 'Rainbow arc', subject: 'a full rainbow arc with a cloud at each end'},
        {key: 'heart', label: 'Rainbow heart', subject: 'a heart filled with rainbow stripes'},
        {key: 'word', label: 'Rainbow word', subject: 'the word "LOVE" lettered in rainbow stripes'},
    ],
    styles: [
        {key: 'holo', label: 'Holographic', style: 'holographic sticker, iridescent rainbow sheen across the surface, glossy', palette: 'Iridescent silver shifting through pink, cyan and gold', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'vinyl', label: 'Vinyl', style: 'glossy vinyl sticker, clean vector shapes, bold flat colour, a small highlight', palette: 'Bright flat colour with a white highlight', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
    ],
    directions: ['a rainbow flag instead', 'a whole sticker sheet', 'as a matching pair'],
    directionHint: 'try: a rainbow flag instead',
    seo: {
        title: 'Rainbow Stickers: Arc, Heart, Love Word',
        metaDescription: 'Nine rainbow stickers — a rainbow arc, a rainbow heart, LOVE in rainbow stripes — in holographic, kawaii, and vinyl styles.',
        h1: 'Rainbow stickers: rainbow arc, rainbow heart, love lettering',
        tagline: 'Nine stickers, three rainbow icons, three styles each.',
        intro: "A full rainbow arc with a cloud at each end, a heart filled with rainbow stripes, and the word 'LOVE' lettered in rainbow stripes — three rainbow stickers, die-cut and ready to print. Each rendered holographic, kawaii, and glossy vinyl. Ask for a different word, a double-rainbow scene, or a pride-flag composition, and the same three styles carry it.",
        useCases: [
            'a laptop or water bottle',
            'a planner or journal page',
            'a phone case sticker sheet',
            'a pride-themed gift or event',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine rainbow stickers — a rainbow arc, a rainbow heart, and LOVE lettering — in holographic, kawaii, and glossy vinyl finishes.'},
            {q: 'Can I get a different word or scene?', a: 'Yes — the direction field takes any variation, including a different word, a double-rainbow scene, or a pride-flag composition.'},
            {q: 'What does the holographic finish print as?', a: 'The holographic design is an illustrated iridescent sheen — print it on holographic vinyl stock for the real shifting effect, or on plain matte stock for a flat colourful version.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
        ],
    },
}
